//REACT
import React, {useContext} from 'react';
//ROUTER
import { BrowserRouter, Route, Switch } from "react-router-dom";

//MUI COMPONENTS
import {makeStyles} from '@material-ui/core/styles';
//CUSTOM COMPONENTS
import NotFound from './NotFound';

import MarketDataContextProvider from '../contexts/MarketDataContext';
import MarketDataTable from './MarketDataTable';

import Navigation from './Navigation';


import Login from './Login';
import {UserContext} from "../contexts/UserContext";
import ClientContextProvider from "../contexts/ClientContext";

import PipList from "./PipList";




const MarketDataList = () => (

        <MarketDataContextProvider>
            <MarketDataTable/>
        </MarketDataContextProvider>

);

const PipsList = () => (
    <ClientContextProvider>
        <PipList/>
    </ClientContextProvider>
);


const useStyles = makeStyles(theme => ({
    offset: theme.mixins.toolbar,
}));



const Router = () => {
    const classes = useStyles();
    let userLogin = useContext(UserContext);
    if(userLogin.amILoggedIn()){
        console.log('I am logged in');
        return ( <BrowserRouter>
            <Navigation/>
            <div className={classes.offset}/>
            <Switch>
                <Route exact path="/home" component={PipsList}/>
                <Route path="/pip/:pipId" component={MarketDataList}/>
                <Route exact path="/login" component={Login}/>
                <Route exact path="/" component={Login}/>
                <Route component={NotFound}/>
            </Switch>
        </BrowserRouter>);
    }
    else{
        return ( <BrowserRouter>
            <Navigation/>
            <div className={classes.offset}/>
            <Switch>
                <Route exact path="/login" component={Login}/>
                <Route component={Login}/>
            </Switch>
        </BrowserRouter>
        );
    }
};

export default Router;